export default class Sidebar {
  constructor() {
    this.init();
  }
  init() {

    // Left sidebar
    const sidebarTrigger = $(".esf-js-sidebarToggle");
    const sidebarElementsPhone = $(".esf-main-sidebar--secondary, .esf-hamburger--sidebar");
    const sidebarElements = $(".esf-main-sidebar--secondary, .esf-hamburger--sidebar, .esf-main-layout--has-inner-sidebar .esf-main-content, .esf-sticky-button-bar--form, .esf-sticky-button-bar--table");

    const sidebarTriggerClickPhone = () => {
      sidebarTrigger.click(function() {
        sidebarElementsPhone.addClass("-has-transition").toggleClass("-is-open");
      });
    };

    const sidebarTriggerClick = () => {
      sidebarTrigger.click(function() {
        sidebarElements.addClass("-has-transition").toggleClass("-is-open");
      });
    };

    const openSidebarPhone = () => {
      sidebarElementsPhone.addClass("-is-open");
    }

    const closeSidebarPhone = () => {
      sidebarElementsPhone.removeClass("-is-open");
    }

    const openSidebar = () => {
      sidebarElements.addClass("-is-open");
    };

    const closeSidebar = () => {
      sidebarElements.removeClass("-is-open");
    };

    const sidebarAddOverlayClass = () => {
      $(".esf-main-content").addClass("esf-main-content--overlay");
    };

    const sidebarRemoveOverlayClass = () => {
      $(".esf-main-content").removeClass("esf-main-content--overlay");
    };

    const sidebarOverlayClick = () => {
      $(".esf-main-content--overlay.-is-open").click(function() {
        closeSidebar();
      });
    };

    sidebarOverlayClick();

    const resetSidebarOverlayClick = () => {
      $(".esf-main-content.-is-open").click(function() {
        openSidebar();
      });
    };

    // Right working space
    const workingSpaceTrigger = $(".esf-js-workingSpaceToggle");
    const workingSpaceElements = $(".esf-main-sidebar--working-space, .esf-main-sidebar--working-space__actions, .esf-hamburger--working-space");

    workingSpaceElements.appendTo(".esf-main-layout");

    const workingSpaceTriggerClick = () => {
      workingSpaceTrigger.click(function() {
        workingSpaceElements.addClass("-has-transition").toggleClass("-is-open");
      });
    };

    workingSpaceTriggerClick();

    enquire.register("(max-width: 767px)", {

      match: () => {
        closeSidebar();
        sidebarTriggerClickPhone();

        $(".esf-app-menu__item > a, .esf-app-menu__sub-item").click(function() {
          closeSidebarPhone();
        });
      },

      deferSetup : true

    });

    enquire.register("(min-width: 768px) and (max-width: 1023px)", {

      match: () => {
        closeSidebar();
        sidebarAddOverlayClass();
        sidebarTriggerClick();
      },

      unmatch: () => {
        sidebarRemoveOverlayClass();
      },

      deferSetup : true

    });

    enquire.register("(min-width: 1024px)", {

      match: () => {
        openSidebar();
        sidebarRemoveOverlayClass();
        sidebarTriggerClick();
      },

      deferSetup : true

    });
  }
}
